import { createSelector } from 'reselect';

const rootSelector = (state) => state.modals;

export const openedModalSelector = createSelector(
  rootSelector,
  ({ openedModal }) => openedModal,
);
